module.exports = __webpack_public_path__ + "img/ground-river-day.03716cda.png";